<template>
  <div>
    <v-card
      style="
        background-color: transparent;
        border-radius: 15px;
        margin-top: 2vw;
      "
      elevation="1"
    >
      <v-card-text>
        <v-container v-if="loading">
          <v-row dense class="mt-9" alig="center" justify="center">
            <v-progress-circular indeterminate></v-progress-circular>
          </v-row>
        </v-container>
        <v-container v-else>
          <v-row>
            <v-row dense>
              <v-col cols="12" md="4"
                ><span class="text-h5"
                  >{{ module.title }} - {{ module.category }}</span
                ></v-col
              >
              <v-col cols="12" md="2"
                ><v-btn plain @click="goBack()"
                  ><v-icon>mdi-chevron-left</v-icon
                  ><strong style="text-transform: capitalize" class="texth7"
                    >Voltar</strong
                  ></v-btn
                ></v-col
              >
            </v-row>
          </v-row>
          <v-row style="margin-top: 3vw">
            <v-card
              elevation="1"
              class="mx-auto px-auto my-auto py-auto"
              width="100vw"
            >
              <v-card-text>
                <v-row dense>
                  <v-col cols="12">
                    <span class="text-h6 font-weight-bold"
                      >Conteúdo do Módulo</span
                    >

                    <v-carousel
                      v-model="carouselIndex"
                      :cycle="false"
                      height="700"
                      hide-delimiters
                      show-arrows-on-hover
                      class="rounded-lg mt-3"
                    >
                      <v-carousel-item
                        v-for="(item, i) in module.content"
                        :key="i"
                        :class="{
                          'content-item-card': true,
                          'video-item': isVideo(item.type),
                        }"
                      >
                        <div
                          class="d-flex align-center px-4 pt-2 content-header"
                        >
                          <h3 class="text-h6 white--text">{{ item.name }}</h3>
                          <v-spacer></v-spacer>
                          <v-chip dark color="secondary-400" class="ma-2">{{
                            getItemTypeLabel(item.type)
                          }}</v-chip>
                          <v-chip dark color="secondary-400"
                            >Visualizando: {{ carouselIndex + 1 }} /
                            {{ module.content.length }}</v-chip
                          >
                        </div>

                        <div
                          class="transparent-content-wrapper fill-height pa-4"
                        >
                          <div v-if="isPDF(item.type)" class="fill-height">
                            <iframe
                              :src="`${item.url}#toolbar=0`"
                              width="100%"
                              height="100%"
                              frameborder="0"
                              allowfullscreen
                            >
                            </iframe>
                          </div>

                          <div v-else-if="isPPT(item.type)" class="fill-height">
                            <iframe
                              :src="googleDocsViewerUrl(item.url)"
                              width="100%"
                              height="100%"
                              frameborder="0"
                              allowfullscreen
                            >
                            </iframe>
                          </div>

                          <div
                            v-else-if="isVideo(item.type)"
                            class="d-flex justify-center align-center fill-height"
                          >
                            <video
                              :width="
                                $vuetify.breakpoint.smAndDown ? '100%' : '800'
                              "
                              height="500"
                              controls
                            >
                              <source :src="item.url" type="video/mp4" />
                              Seu navegador não suporta o elemento de vídeo.
                            </video>
                          </div>
                        </div>
                      </v-carousel-item>
                    </v-carousel>
                  </v-col>
                </v-row>

                <v-row dense class="mt-8">
                  <v-col cols="12">
                    <span class="text-h6 font-weight-bold">Keywords</span>
                    <v-expansion-panels class="mt-3">
                      <v-expansion-panel
                        v-for="(item, i) in module.keywords"
                        :key="i"
                      >
                        <v-expansion-panel-header>
                          {{ item.keyword }}
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <span class="text-h6">{{ item.description }}</span>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import pitchPartnerApi from "@/shared/pitchPartnerApi";
import { format } from "date-fns";
export default {
  name: "CourseContentPage",
  components: {},
  async created() {
    await pitchPartnerApi
      .getCourseContent(this.$route.params.module, this.$route.params.id)
      .then((res) => {
        this.moduleId = this.$route.params.id;
        this.loading = false;
        this.module = res.data.content;
      })
      .catch((err) => {
        console.log(err);
      });
  },
  data() {
    return {
      module: {},
      moduleId: "",
      tab: "tab-1",
      loading: true,
      comments: [],
      totalComments: 0,
      reverse: false,
      comment: "",
      carouselIndex: 0,
    };
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    googleDocsViewerUrl(url) {
      return `https://docs.google.com/gview?url=${encodeURIComponent(
        url
      )}&embedded=true`;
    },
    formatDate(date) {
      if (date) return format(date, "dd/MM/yyyy HH:mm");
    },
    isPDF(filename) {
      return filename.includes("pdf");
    },
    isVideo(filename) {
      return filename.includes("mp4");
    },
    isPPT(filename) {
      return (
        filename.includes("presentation") ||
        filename.includes("ppt") ||
        filename.includes("pptx") ||
        filename.includes("powerpoint")
      );
    },
    getItemTypeLabel(type) {
      if (this.isPDF(type)) return "PDF";
      if (this.isPPT(type)) return "PPT/Apresentação";
      if (this.isVideo(type)) return "Vídeo";
      return "Conteúdo";
    },
  },
  watch: {
    reverse() {
      this.comments.reverse();
    },
    // Opcional: pausar o vídeo ao trocar o item, se necessário
    carouselIndex() {
      // Lógica para pausar vídeos pode ser adicionada aqui,
      // mas requer a customização do player para expor um método de pause.
    },
  },
};
</script>
<style scoped>
/* Estilos para garantir que o iframe e o vídeo ocupem o espaço corretamente */
.fill-height {
  height: 100%;
}

/* 1. FLEXBOX NO ITEM DO CARROSSEL (Define a altura base) */
.v-carousel-item {
  background: #424242;
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* 2. HEADER */
.content-header {
  background-color: rgba(0, 0, 0, 0.3);
  padding: 8px 16px;
  z-index: 1;
  width: 100%;
  flex-shrink: 0;
}

/* 3. WRAPPER DE CONTEÚDO (Ocupa o espaço restante) */
.transparent-content-wrapper {
  background-color: transparent !important;
  padding: 16px !important;
  flex-grow: 1;
  height: 100%; /* Essencial para herdar a altura do flex-grow */

  display: flex;
  justify-content: center;
  align-items: center;
}

/* 4. ALVO FINAL: Garante que o iframe e seu contêiner interno preencham a altura */
/* Selecionador mais específico para a DIV interna do v-if */
.transparent-content-wrapper > div {
  height: 100%;
  width: 100%;
}

/* Força o iframe a preencher o 100% do seu contêiner pai (.transparent-content-wrapper > div) */
.transparent-content-wrapper iframe {
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
}

/* Estilo para o item de vídeo, se necessário uma cor de fundo diferente */
.content-item-card.video-item {
  background: #000000;
}

/* Ajuste para o vídeo nativo dentro do carrossel */
.transparent-content-wrapper video {
  max-width: 100%;
  /* Deixe a altura ser ajustada pelo aspect ratio do vídeo, mas limite o tamanho */
  max-height: 100%;
}
</style>
